export default function Hero() {
  return (
    <section className="py-20 md:py-28 border-b border-line relative overflow-hidden" id="top">
      <div className="max-w-6xl mx-auto px-6">
        <div
          className="inline-flex items-center gap-2 px-3 py-1 bg-ground-elevated border border-line-light text-gold text-xs mono-tag uppercase tracking-wider mb-8 fade-seq-1"
          data-testid="hero-badge"
        >
          <span className="w-2 h-2 rounded-full bg-gold animate-pulse"></span>
          Studio Direct &middot; Original Abstract &amp; Landscapes
        </div>

        <div className="hero-title-font text-6xl md:text-8xl lg:text-[7.5rem] uppercase text-white mb-8">
          <h1 className="block">
            <span className="ln">
              <span>RARE VIBRANT SCAPES</span>
            </span>
            <span className="ln">
              <span className="text-gold">BUILT FOR SPACES</span>
            </span>
            <span className="ln">
              <span>THAT DEMAND CHARACTER.</span>
            </span>
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end fade-seq-2">
          <div className="md:col-span-7">
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-light">
              My style is distinctive and hard to find.
            </p>
            <p className="text-sm text-slate-400 mt-2">
              Upload new original pieces anytime, sell directly with instant buy
              buttons, or accept custom commissions.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-wrap gap-4 md:justify-end">
            <a
              href="#add-piece"
              className="px-6 py-3.5 bg-gold text-black font-semibold uppercase tracking-wider text-xs hover:bg-gold-hover transition-colors"
              data-testid="hero-add-piece-btn"
            >
              + Add New Piece
            </a>
            <a
              href="#gallery"
              className="px-6 py-3.5 bg-white text-black font-semibold uppercase tracking-wider text-xs hover:bg-gold transition-colors"
              data-testid="hero-browse-gallery-btn"
            >
              Browse Gallery
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
